export const getLotsWithPmfText = (lots) => {
    let lotsWithPmfText = [];
    lots?.forEach(lot => {
        let l = { ...lot };
        if (!l.pmfLot)
            l.name = lot.name + ' (Non PMF Lot)';
        lotsWithPmfText.push(l);
    })
    return lotsWithPmfText;
}